"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateAppConfig = function (user) {
    var config = {};
    var scopes = user.scopes, gates = user.gates;
    var isOrgAdmin = utils_1.getIsOrgAdmin(scopes);
    // check access to automation application
    config = ramda_1.set(ramda_1.lensProp('hasAutomation'), !!gates.has_automation && isOrgAdmin, config);
    return config;
};
exports["default"] = generateAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/automationWeb/index.js
// module id = PTmF
// module chunks = 88